import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState, useCallback } from "react";
import { LoginControlByUserGuidResponse } from "../../Model/Response/ClientAgent/LoginControlByUserGuidResponse";
import { LoginControlByUserGuidRequest } from "../../Model/Request/ClientAgent/LoginControlByUserGuidRequest";
import { ApiBaseResponse, ResponseCode } from "../../Model/Response/Common/ApiBaseResponse";
import { AssingHubIdToAlbUser, LoginControlByUserGuid } from "../../Controller/Api/ClientAgentController";
import { GlobalOperations } from "../../Controller/Common/GlobalOperations";
import Sidebar from "./Sidebar";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import { AssingHubIdToAlbUserRequest } from "../../Model/Request/ClientAgent/AssingHubIdToAlbUserRequest";
import { ChatProvider, useChat } from "./ChatContext"; // ChatContext'i ekliyoruz
import { StatusMessageProvider } from "../Components/CoreComponents/StatusMessage";

// ChatProvider içerisine alınıyor
const ChatWindow: React.FC = () => {
    return (
        <ChatProvider>
            <ChatWindowContent />
        </ChatProvider>
    );
};

const ChatWindowContent: React.FC = () => {
    // State tanımları
    const [isConnectionFailed, setIsConnectionFailed] = useState<boolean>(false);
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
    const chatWindowRef = useRef<HTMLDivElement>(null);

    // Chat contextinden startSignalR ve isSignalRStarted fonksiyonları
    const { startSignalR } = useChat();

    // URL'den gelen parametreler
    const { lang } = useParams<{ lang: string }>();
    const query = new URLSearchParams(useLocation().search);
    const side = query.get('side');
    const uid = query.get('uid');
    const oid = query.get('oid');

    // Albinasoft agent verilerini çeken asenkron fonksiyon
    const fetchAlbinasoftAgentData = useCallback(async (uid: string | null, oid: string | null, retryCount = 0) => {
        try {
            if (!uid || !oid) {
                setIsAuthorized(false);
                return;
            }

            // Kullanıcı doğrulama isteği
            let request: LoginControlByUserGuidRequest = {
                guid: uid,
                userId: Number(oid)
            };

            const response: ApiBaseResponse<LoginControlByUserGuidResponse> | null =
                await LoginControlByUserGuid(request);

            if (response?.responseCode !== ResponseCode.OK || !response.content) {
                setIsAuthorized(false);
                return;
            }

            // Kullanıcı bilgilerini global state'e yazıyoruz
            GlobalOperations.UserName = `${response.content.name} ${response.content.surname}`;
            GlobalOperations.UserToken = response.content.jwtToken;

            // SignalR başlatma
            await startSignalR();

            if (!GlobalOperations.SignalRConnection) {
                setIsConnectionFailed(true);
                return;
            }

            // Kullanıcı ve SignalR bağlantısını eşleştirme isteği
            let signalRequest: AssingHubIdToAlbUserRequest = {
                userGuid: response.content.userToken,
                hubGuid: GlobalOperations.ConnectionHubId
            };

            let responseHub: ApiBaseResponse<null> | null =
                await AssingHubIdToAlbUser(signalRequest);

            if (!responseHub || responseHub.responseCode != ResponseCode.OK) {
                setIsAuthorized(false);
                return;
            }

            // Başarılı kimlik doğrulama
            setIsAuthorized(true);

        } catch (error) {
            console.error('API çağrısı başarısız:', error);
            if (retryCount < 4) {
                // Hata durumunda 2 saniye sonra yeniden dene
                setTimeout(() => fetchAlbinasoftAgentData(uid, oid, retryCount + 1), 2000);
            } else {
                setIsConnectionFailed(true);
            }
        }
    }, [startSignalR]);


    // İlk yüklendiğinde albinasoft verilerini çek
    useEffect(() => {
        if (side !== 'albinasoft') {
            setIsConnectionFailed(true);
            setIsAuthorized(false); 
          
        } else {
            document.title = "AlbinaSoft Chat Yönetimi";
            fetchAlbinasoftAgentData(uid, oid);
        }
    }, [side, uid, oid]);


    // Bağlantı başarısız olursa gösterilecek hata
    if (isConnectionFailed) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white'
            }}>
                <h1>Chat sunucusu ile bağlantı kurulamadı</h1>
            </div>
        );
    }


    // Yüklenme sırasında gösterilecek ekran
    if (isAuthorized === null) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white'
            }}>
                <h1>Yükleniyor...</h1>
            </div>
        );
    }

    // Yetkisiz kullanıcı durumu
    if (!isAuthorized) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white'
            }}>
                <h1>Yetkisiz Kullanıcı</h1>
            </div>
        );
    }


    // Yetkilendirilmiş kullanıcı için chat ekranı
    return (
        <div className="app-container" style={{ display: 'flex', height: '100vh' }}>
            <StatusMessageProvider>
                <Sidebar />
            </StatusMessageProvider>
            <div ref={chatWindowRef} className="chat-window" style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflowY: 'auto', flexGrow: 1 }}>
                <MessageList />
                <MessageInput />
            </div>
        </div>
    );
};

export default ChatWindow;
